/* =====================================================================
   TPW cart PAGE (/cart) — interactions.
   Works WITH the theme cart.js engine (qty/remove + its cart:change event)
   rather than replacing it. All handlers are event-delegated so they keep
   working after cart.js / our own re-renders.
   ===================================================================== */
(function () {
  "use strict";
  if (window.__tpwCartPage) return;
  window.__tpwCartPage = true;

  var SECTION = "main-cart-items";
  var REC_SECTION = "cart-recommendations";
  var lastCart = null;

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function root() { return q(".tpw-cp"); }
  function ctrl() { return q(".tpw-cp-ctrl"); }
  function threshold() {
    var el = root();
    var v = el && parseInt(el.getAttribute("data-free"), 10);
    return v && v > 0 ? v : 15000;
  }
  function money(cents) { return "$" + (cents / 100).toFixed(2); }
  // SEC (Aegis): HTML-escape any value interpolated into innerHTML (mirrors cart-upsell.js).
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function thrDollars() { return Math.round(threshold() / 100); }
  function live(msg) { var l = q("#tpw-cp-live"); if (l) l.textContent = msg; }
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
  }
  function fetchSectionDoc() {
    return fetch(window.location.pathname + "?section_id=" + SECTION, { headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, "text/html"); })
      .catch(function () { return null; });
  }
  function swap(doc, selector) {
    if (!doc) return;
    var src = doc.querySelector(selector), dst = q(selector);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }
  function reinitMeter() {
    var ci = q("cart-items");
    if (ci && typeof ci.initCartShipping === "function" && q(".cart-shipping")) {
      try { ci.initCartShipping(); } catch (e) {}
    }
  }
  function refreshDispatch() {
    if (typeof window.tpwDispatchApply === "function") {
      try { window.tpwDispatchApply(); } catch (e) {}
    }
  }

  /* mirror the estimated total into the sticky bar (the CTA price lives inside the
     re-rendered sumdyn region, so it updates on swap). */
  function mirrorPrices() {
    var est = q("[data-tpw-est]");
    var stickySub = q("#tpw-cp-sticky-sub");
    if (est && stickySub) stickySub.textContent = est.textContent.trim();
  }

  /* ---------- sync the bits that live outside re-rendered regions ---------- */
  function syncCustom(cart) {
    lastCart = cart || lastCart;
    // header count
    var cnt = q("#tpw-cp-count");
    if (cnt && cart) cnt.textContent = cart.item_count + (cart.item_count === 1 ? " item" : " items");
    // sticky label: "Total" when delivery is free, else "Est. total"
    var slabel = q("#tpw-cp-sticky-label");
    if (slabel && cart) slabel.textContent = cart.total_price >= threshold() ? "Total" : "Est. total";
    mirrorPrices();
    refreshDispatch();
  }

  /* swap our custom server-rendered regions from a fetched doc */
  function refreshCustomRegions(doc) {
    swap(doc, ".tpw-rig-contents");
    swap(doc, ".tpw-cp-sumdyn-contents");
  }

  /* full region swap (used after our own /cart/add.js) */
  function refreshAll(doc) {
    if (!doc) return;
    swap(doc, ".js-contents");
    swap(doc, ".js-contents-totals");
    swap(doc, ".js-contents-shipping");
    refreshCustomRegions(doc);
    reinitMeter();
  }

  /* ---------- one-tap add (picker / rail / empty bestsellers) ---------- */
  function addVariant(variantId) {
    // suppress the global interceptor's drawer-open. __tpwIcptBusy (3s) is the robust
    // guard: it holds even if the add is slow on mobile, where a time-only __tpwCartHandled
    // (2s) could lapse and let the drawer pop over the cart page.
    window.__tpwCartHandled = Date.now();
    window.__tpwIcptBusy = Date.now();
    window.__tpwCartOpenGuard = Date.now();
    var body = JSON.stringify({
      id: Number(variantId), quantity: 1,
      sections: SECTION + ",cart-icon-bubble",
      sections_url: window.location.pathname
    });
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body
    }).then(function (r) { return r.json(); });
  }

  function onAddClick(btn) {
    if (btn.classList.contains("is-added") || btn.disabled) return;
    var variant = btn.getAttribute("data-variant");
    if (!variant) return;
    var reload = btn.hasAttribute("data-tpw-reload");
    btn.classList.add("is-added");
    var label = btn.textContent;
    btn.textContent = "Added ✓";
    addVariant(variant).then(function (res) {
      if (!res || res.status) {                 // sold out / error
        btn.classList.remove("is-added"); btn.textContent = label;
        live("Sorry, that item could not be added.");
        return;
      }
      if (reload) { window.location.reload(); return; }
      window.__tpwCartHandled = Date.now();
      // swap the cart icon bubble if returned
      if (res.sections && res.sections["cart-icon-bubble"]) {
        var bubble = q("#cart-icon-bubble");
        if (bubble) {
          var d = new DOMParser().parseFromString(res.sections["cart-icon-bubble"], "text/html");
          var s = d.querySelector(".shopify-section");
          bubble.innerHTML = s ? s.innerHTML : bubble.innerHTML;
        }
      }
      // swap cart regions from the returned section
      if (res.sections && res.sections[SECTION]) {
        var doc = new DOMParser().parseFromString(res.sections[SECTION], "text/html");
        refreshAll(doc);
      }
      getCart().then(function (cart) {
        syncCustom(cart);
        hydrateRail(cart);
        var added = (lastCart && lastCart.items || []).length;
        live("Added to your setup. Subtotal " + (cart ? money(cart.total_price) : "") + ".");
      });
    }).catch(function () {
      btn.classList.remove("is-added"); btn.textContent = label;
    });
  }

  /* ---------- undo toast on remove ---------- */
  var pendingRemoval = null, toastTimer = null;
  function showToast(title) {
    var t = q("#tpw-cp-toast"), m = q("#tpw-cp-toast-msg");
    if (!t || !m) return;
    m.textContent = (title ? title : "Item") + " removed";
    t.classList.add("is-shown");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("is-shown"); pendingRemoval = null; }, 5500);
  }
  function onRemoveClick(a) {
    pendingRemoval = {
      variant: a.getAttribute("data-tpw-variant"),
      qty: parseInt(a.getAttribute("data-tpw-qty"), 10) || 1,
      title: a.getAttribute("data-tpw-title") || ""
    };
    showToast(pendingRemoval.title);   // cart.js performs the actual removal
  }
  function onUndo() {
    if (!pendingRemoval) return;
    var r = pendingRemoval; pendingRemoval = null;
    var t = q("#tpw-cp-toast"); if (t) t.classList.remove("is-shown");
    window.__tpwCartHandled = Date.now();
    window.__tpwIcptBusy = Date.now();
    window.__tpwCartOpenGuard = Date.now();
    var body = JSON.stringify({
      id: Number(r.variant), quantity: r.qty,
      sections: SECTION + ",cart-icon-bubble", sections_url: window.location.pathname
    });
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        if (res && res.sections && res.sections[SECTION]) {
          refreshAll(new DOMParser().parseFromString(res.sections[SECTION], "text/html"));
        }
        return getCart();
      })
      .then(function (cart) { syncCustom(cart); hydrateRail(cart); live("Item restored."); })
      .catch(function () {});
  }

  /* ---------- rig: node -> picker, toggle, tags ---------- */
  function pickersWrap() { return q(".tpw-cp-rig__pickers"); }
  function closeAllPickers() {
    qa(".tpw-cp-picker").forEach(function (p) { p.hidden = true; });
    qa(".tpw-cp-node").forEach(function (n) { n.classList.remove("is-active"); });
    qa(".tpw-cp-node--miss").forEach(function (n) { n.setAttribute("aria-expanded", "false"); });
  }
  function openPicker(node) {
    var part = node.getAttribute("data-part");
    var picker = q('.tpw-cp-picker[data-part="' + part + '"]');
    if (!picker) return;
    var wasOpen = !picker.hidden;
    closeAllPickers();
    if (wasOpen) return;                 // toggle off
    picker.hidden = false;
    node.classList.add("is-active");
    node.setAttribute("aria-expanded", "true");
    // "tips you over $X" tag on qualifying cards (needs a known cart total)
    var gap = lastCart ? (threshold() - lastCart.total_price) : -1;
    qa(".tpw-cp-card", picker).forEach(function (card) {
      var tag = card.querySelector(".tpw-cp-card__tag");
      var price = parseInt(card.getAttribute("data-price"), 10) || 0;
      if (tag && gap > 0 && price >= gap) {
        tag.textContent = "Tips you over $" + thrDollars() + ", free delivery";
        tag.hidden = false;
      } else if (tag) { tag.hidden = true; }
    });
  }
  function toggleRig(btn) {
    var rig = btn.closest(".tpw-cp-rig"); if (!rig) return;
    var open = rig.classList.toggle("tpw-cp-rig--open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    var lab = q("[data-tpw-rig-togglelab]", btn); if (lab) lab.textContent = open ? "Hide" : "Show";
    if (!open) closeAllPickers();
  }

  /* ---------- pairs-well-with rail (rec engine, like the drawer) ---------- */
  function railCard(c) {
    return '<div class="tpw-cp-card tpw-cp-card--rail" data-pid="' + esc(c.pid) + '" data-price="' + esc(c.price) + '">' +
      '<a class="tpw-cp-card__img" href="' + esc(c.url) + '" tabindex="-1" aria-hidden="true">' +
        (c.img ? '<img class="tpw-cp-card__imgel" src="' + esc(c.img) + '" alt="" width="300" height="300" loading="lazy" decoding="async">' : '') +
      '</a>' +
      '<p class="tpw-cp-card__n"><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></p>' +
      '<p class="tpw-cp-card__p">' + money(c.price) + '</p>' +
      '<span class="tpw-cp-card__tag" hidden></span>' +
      '<button type="button" class="tpw-cp-card__add" data-tpw-add data-variant="' + esc(c.variant) + '" aria-label="Add ' + esc(c.title) + ' to your setup">Add</button>' +
    '</div>';
  }
  function recFor(pid, intent) {
    return fetch("/recommendations/products?section_id=" + REC_SECTION + "&product_id=" + pid + "&intent=" + intent + "&limit=8", { headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, "text/html");
        return qa(".tpw-up-card", d).map(function (el) {
          return {
            pid: el.getAttribute("data-pid"), variant: el.getAttribute("data-variant"),
            available: el.getAttribute("data-available") === "1",
            price: parseInt(el.getAttribute("data-price"), 10) || 0,
            title: el.getAttribute("data-title") || "", url: el.getAttribute("data-url") || "#",
            img: el.getAttribute("data-img") || ""
          };
        });
      }).catch(function () { return []; });
  }
  var railBusy = false;
  function railSection() { return q(".tpw-cp-grid__rail"); }
  function hydrateRail(cart) {
    var row = q("#tpw-cp-rail"), sect = railSection();
    if (!row || railBusy) return;
    cart = cart || lastCart;
    if (!cart || !cart.items || !cart.items.length) { row.innerHTML = ""; if (sect) sect.hidden = true; return; }
    railBusy = true;
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var seeds = cart.items.slice(0, 3).map(function (i) { return i.product_id; });
    // complementary FIRST (curated), then related as fallback — mirrors the drawer engine
    var jobs = [];
    seeds.forEach(function (pid) { jobs.push(recFor(pid, "complementary")); });
    seeds.forEach(function (pid) { jobs.push(recFor(pid, "related")); });
    Promise.all(jobs).then(function (lists) {
      var seen = {}, cards = [];
      lists.forEach(function (list) {
        list.forEach(function (c) {
          if (c.available && c.pid && !inCart[c.pid] && !seen[c.pid]) { seen[c.pid] = true; cards.push(c); }
        });
      });
      cards = cards.slice(0, 8);
      if (cards.length) { row.innerHTML = cards.map(railCard).join(""); if (sect) sect.hidden = false; }
      else { row.innerHTML = ""; if (sect) sect.hidden = true; }
    }).catch(function () {}).then(function () { railBusy = false; });
  }

  /* ---------- collapsibles + promo ---------- */
  function toggleColl(headBtn) {
    var coll = headBtn.closest("[data-tpw-coll]"); if (!coll) return;
    var open = coll.classList.toggle("is-open");
    headBtn.setAttribute("aria-expanded", open ? "true" : "false");
  }
  function applyPromo() {
    var input = q("[data-tpw-promo-input]"), msg = q("[data-tpw-promo-msg]");
    var code = (input && input.value || "").trim();
    if (!code) { if (msg) { msg.hidden = false; msg.className = "tpw-cp-coll__msg is-err"; msg.textContent = "Enter a code first"; } return; }
    if (msg) { msg.hidden = false; msg.className = "tpw-cp-coll__msg is-ok"; msg.textContent = "Applying " + code + "…"; }
    window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
  }

  /* ---------- sticky bottom bar ---------- */
  function initSticky() {
    /* CRO: the sticky checkout bar is DEFAULT-ON whenever the real checkout area
       (the sumdyn block, which holds the primary "Go to checkout" button) is not
       in view — so on mobile there is always a visible checkout path. The sumdyn
       WRAPPER persists across re-renders (only its inner content is swapped), so
       the observer survives cart changes. */
    var target = q("[data-tpw-sumdyn]"); var bar = q("#tpw-cp-sticky");
    if (!target || !bar || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var c = ctrl();
        var show = !en.isIntersecting && c && !c.classList.contains("is-empty");
        bar.classList.toggle("is-shown", show);
        bar.setAttribute("aria-hidden", show ? "false" : "true");
      });
    }, { threshold: 0, rootMargin: "0px 0px -8px 0px" });
    io.observe(target);
  }

  /* ---------- delegated events ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var add = t.closest && t.closest("[data-tpw-add]");
    if (add) { e.preventDefault(); onAddClick(add); return; }
    var rm = t.closest && t.closest("[data-tpw-remove]");
    if (rm) { onRemoveClick(rm); return; }                 // do NOT preventDefault — cart.js removes
    var undo = t.closest && t.closest("#tpw-cp-toast-undo");
    if (undo) { e.preventDefault(); onUndo(); return; }
    var rigToggle = t.closest && t.closest("[data-tpw-rig-toggle]");
    if (rigToggle) { e.preventDefault(); toggleRig(rigToggle); return; }
    var node = t.closest && t.closest(".tpw-cp-node--miss");
    if (node) { e.preventDefault(); openPicker(node); return; }
    var collT = t.closest && t.closest(".tpw-cp-coll__t");
    if (collT) { e.preventDefault(); toggleColl(collT); return; }
    var promo = t.closest && t.closest("[data-tpw-promo-apply]");
    if (promo) { e.preventDefault(); applyPromo(); return; }
  });

  /* react to cart.js qty/remove.
     INP: a burst of +/- stepper taps fires cart:change repeatedly. mirrorPrices()
     updates the visible totals INSTANTLY (optimistic), but the heavy section
     refetch + rail rehydrate is DEBOUNCED so the burst collapses to one network
     cycle instead of a full refetch + up to 6 /recommendations fetches per tap. */
  var heavyT = 0;
  function heavyRefresh() {
    clearTimeout(heavyT);
    heavyT = setTimeout(function () {
      fetchSectionDoc().then(function (doc) {
        refreshCustomRegions(doc);
        return getCart();
      }).then(function (c) {
        syncCustom(c);
        hydrateRail(c);
      });
    }, 350);
  }
  document.addEventListener("cart:change", function (e) {
    mirrorPrices();      // instant optimistic update
    heavyRefresh();      // debounced heavy refresh
  });
  document.addEventListener("cart:error", function () { /* cart.js shows the inline error */ });

  /* ---------- init ---------- */
  function init() {
    initSticky();
    getCart().then(function (cart) {
      lastCart = cart;
      syncCustom(cart);
      hydrateRail(cart);
    });
    refreshDispatch();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
